'use client';
function wrapWithSelector(selectors, code) {
  const _selectors = Array.isArray(selectors) ? selectors : [selectors];
  return _selectors.reduce((acc, selector) => `${selector}{${acc}}`, code);
}

export { wrapWithSelector };
//# sourceMappingURL=wrap-with-selector.mjs.map
